export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
export const IN_FLIGHT = 'IN_FLIGHT';
